module.exports = __webpack_public_path__ + "images/hoehenlinien-2111af3fdf23644e70e9252e56fa8999.png";